angular.module('picmonicpublic')
    .controller('BbController', ['$rootScope', '$scope', 'BundleBuyService', 'MarketOptionsConfig', function ($rootScope, $scope, BundleBuyService, MarketOptionsConfig) {
        $scope.base_asset_url = $rootScope.base_asset_url;
        $scope.BundleBuyService = BundleBuyService;
        $scope.market = MarketOptionsConfig.getMarketById(100);
    }]);
